import { memo } from "react";
import { literals } from "@/constants/literals";
import useExitsDataStore from "@/store/useExitsData.store";
import ExpandableOrderHeader from "../../components/explandable-order-header/ExpandableOrderHeader";
import { formatBooleanText } from "@/lib/texts.utils";

export interface SendOrderHeaderProps {
  newOrderText?: boolean;
  inResumePage?: boolean;
}

const ExitsOrderHeader = ({
  newOrderText,
  inResumePage,
}: SendOrderHeaderProps) => {
  const { exitsData, exitsGroupData } = useExitsDataStore();

  const basicInformation: [
    { label: string; value: string },
    { label: string; value: string },
  ] = [
    {
      label: literals.step,
      value: exitsData.step,
    },
    {
      label: literals.document9R1,
      value: exitsData.document9r1,
    },
  ];

  const expandedDetails = () => {
    if (newOrderText) return;

    const details = [
      {
        label: literals.orderOut,
        value: exitsData.orderOut,
      },
      {
        label: literals.serialOut,
        value: exitsData.serialOut,
      },
      {
        label: literals.client,
        value: exitsData.customer,
      },
      {
        label: literals.packageReference,
        value: exitsData.packagingReference,
      },
      {
        label: literals.ownPackaging,
        value: formatBooleanText(exitsData.ownPackaging),
      },
      {
        label: literals.correctPackaging,
        value: formatBooleanText(exitsData.correctPackaging),
      },
      {
        label: literals.damagedPackaging,
        value: formatBooleanText(exitsData.damagedPackaging),
      },
    ];
    if (exitsData.step === literals.presendsAction)
      details.push({
        label: literals.iberiaPackaging,
        value: formatBooleanText(exitsData.iberiaPackagingOut),
      });
    details.push({
      label: literals.ownPackagingOut,
      value: formatBooleanText(exitsData.ownPackagingOut),
    });
    return details;
  };

  return (
    <ExpandableOrderHeader
      stand="exits"
      newOrderText={newOrderText}
      inReceptionResumePage={inResumePage}
      basicInformation={basicInformation}
      expandedInformation={expandedDetails()}
      thereAreMoreGroups={exitsGroupData.length > 0}
    />
  );
};
export default memo(ExitsOrderHeader);
